$(document).ready(function () {
  //제품 정보 주입
  const productData = {
    boosterPro: {
      id: "boosterPro",
      name: "ブースタープロ",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_booster_bk.png?v=1768198626",
            width: "100px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_booster_pk.png?v=1768198626",
            width: "100px",
          },
        ],
        colors: ["#000000", "#FFCDCD"],
        link: "/products/boosterpro",
      },
      specs: {
        モード: ["ブースターモード", "ダーマショットモード", "MCモード", "エアショットモード"],
        重量: ["154g"],
        搭載技術: ["グロウポレーション", "中周波(EMS)", "微細電流", "ポアポレーション"],
        肌ターゲット層: [
          "角質層",
          "表皮層",
          "真皮層",
          "筋肉層",
        
        ],
        主要モード: [
          "有効成分浸透ケア",
          "ハリケア",
          "輪郭ケア",
          "毛穴ケア",
          "肌外側の弾力",
        
        ],
        肌悩み: [
          "肌の乾燥",
          "乾燥による小じわ",
          "毛穴の目立ち",
          "筋肉のたるみ",
        
        ],

        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
        アプリ連動: [
          "可能",
        ],
      },
    },
    boosterMini: {
      id: "boosterMini",
      name: "ブースタープロミニプラス",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_mini_pk.png?v=1768199524",
            width: "100px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_mini_wh.png?v=1768199524",
            width: "100px",
          },
        ],
        colors: ["#FFCDCD", "#EFEFEF"],
        link: "/products/agerboosterprominiplus",
      },
      specs: {
        モード: [
          { main: "レッドLEDモード（透明感*ケア）", sub: "*キメが整ったことによる肌印象のこと <br> ※機能性商品を併用時" },
          { main: "ブルーLEDモード（トラブル*ケア）", sub: "*乾燥や外的刺激による肌コンディションの乱れのこと <br> ※機能性商品を併用時" },
          { main: "パープルLEDモード（ツヤケア）"},
        ],
        重量: ["75g"],
       搭載技術: ["グロウポレーション "],
       肌ターゲット層  : [
          "表皮層",

        ],
       主要モード: [
        { main: "有効成分浸透" },

        {
          main: "トラブル*ケア",
          sub: "*乾燥や外的刺激による肌コンディションの乱れのこと"
        },
        {
          main: "透明感*ケア",
          sub: "*キメが整ったことによる肌印象のこと"
        },
        {
          main: "つや*ケア",
          sub: "*うるおいによる肌印象のこと"
        }
],
        肌悩み: [
          { main: "肌の乾燥" },
          { main: "トラブル", sub: "*敏感・刺激・乾燥・ざらつきなどの肌悩み" },
          { main: "色のムラ"},
          { main: "インナードライ"},

        ],
        アクセサリー互換 : [
          "可能",
        ],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
   
        アプリ連動: [
          "可能",
        ],
      },
    },
    boosterx2: {
      id: "boosterx2",
      name: "ブースタープロX2",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0518/4123/7168/files/x2_pk.png?v=1771824294",
            width: "100px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0518/4123/7168/files/x2_wh.png?v=1771824294",
            width: "100px",
          },
        ],
        colors: ["#FFCDCD", "#EFEFEF"],
        link: "/products/booster-pro-x2",
      },
      specs: {
        
         モード: ["ブースター X2 モード", "ダーマショット X2 モード", "中周波(MC X2 モード)", "エアショット X2 モード", "マスクモード", "デュアルモード"],

        重量: ["230g"],
       搭載技術: ["グロウポレーション ", "中周波(EMS) ", "微細電流 ", "ポアポレーション ", "ブースターデュアルテク ", "AIケア "],
           肌ターゲット層  : [
          "角質層", "皮脂層",  "真皮層",  "筋肉層"

        ],
        主要モード: [
          { main: "有効成分浸透ケア" },
          { main: "ハリケア"},
          { main: "輪郭ケア"},
          { main: "毛穴ケア"},
          { main: "弾力ケア"},
          { main: "透明感* ケア", sub: "*キメが整ったことによる肌印象のこと" },
          { main: "沈静ケア", sub: "*乾燥による肌荒れを防ぐこと" },

        ],
        肌悩み: [
          "肌の乾燥",
          "乾燥による小じわ",
          "毛穴の目立ち",
          "フェイスライン",
        
        ],
        "Accessory Compatibility": [
,
        ],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
   
        アプリ連動: [
          "可能",
        ],
      },
    },
    vroller: {
      id: "vroller",
      name: "リフトEMSローラー",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0518/4123/7168/files/roller_pk.png?v=1771824553",
            width: "130px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0518/4123/7168/files/roller_wh.png?v=1771824552",
            width: "130px",
          },
        ],
        colors: ["#FFCDCD", "#EFEFEF"],
        link: "https://www.qoo10.jp/g/1129022730",
      },
      specs: {
         モード: [
          { main: "レッドモード（リフトケア*)", sub: "*マッサージによる肌のハリ感・引き締まった印象" },
          { main: "ブルーモード（引き締め*ケア）", sub: "*マッサージによる一時的な引き締め感" },
          { main: "パープルモード（ボディケア）"},
        ],

        重量: ["145g"],
        搭載技術: ["中周波(EMS)"],
        肌ターゲット層 : [
          "筋肉層",

        ],
        主要モード: [
    
          { main: "リンパマッサージ", sub: "*肌表面へのマッサージによる一時的な体感" },
          { main: "リフトケア", sub: "*マッサージによる肌のハリ感・引き締まっ<br>た印象" },
          { main: "引き締めケア", sub: "*マッサージによる一時的な引き締め感" },
          { main: "肌内側の弾力"},

        ],
        肌悩み: [
          "二重顎",
          "顎周りのもたつき",
          "乾燥にる小じわ",
          "僧帽筋",
        
        ],
        "Accessory Compatibility": [
,
        ],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
   
        アプリ連動: [
          "可能",
        ],
      },
    },
    cleanser : {
      id: "cleanser ",
      name: "振動リフトクレンザーヘッド ",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0518/4123/7168/files/cleanser_pk.png?v=1771918746",
            width: "100px",
          },
           {
            src: "https://cdn.shopify.com/s/files/1/0518/4123/7168/files/cleanser_wh.png?v=1771918746",
            width: "100px",
          },
        ],
         colors: ["#FFCDCD", "#EFEFEF"],
        link: "https://www.qoo10.jp/g/1129022730",
      },
      specs: {
        モード: ["デイリーモード", "ディープモード", "マイルドモード"],
        重量: ["140g"],
        搭載技術: ["３D立体振動", "ブースターソニック", "中周波(EMS)"],
        肌ターゲット層 : [
          "角質層", "筋肉層"

        ],
        主要モード: [
          "ディープクレンジング",
          "毛穴ケア",

        ],
        肌悩み: [
          "肌の老廃物",
          "皮脂 & 角質",
          "毛穴",
     
        
        ],
        "Accessory Compatibility": [
,
        ],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
   
        アプリ連動: [
          "可能",
        ],
      },
    },
    focus: {
      id: "focus",
      name: "ハイフォーカスショットプラス",
      info: {
        images: [
          {
            src: "https://cdn.shopify.com/s/files/1/0518/4123/7168/files/focus_pk.png?v=1771919397",
            width: "100px",
          },
          {
            src: "https://cdn.shopify.com/s/files/1/0518/4123/7168/files/focus_wh.png?v=1771919397",
            width: "100px",
          },
        ],
        colors: ["#FFCDCD", "#EFEFEF"],
        link: "https://www.qoo10.jp/g/1130201974",
      },
      specs: {
       モード:[],
        重量: ["280g"],
        搭載技術: ["高密度焦点式超音波(HIFU)", "スキンブースティング"],
        肌ターゲット層 : [
          "真皮層", "筋膜層"

        ],
        主要モード: [
    
          { main: "リフトケア", sub: "*マッサージによる肌の引き締まった印象" },
          { main: "肌外側の弾力"},
          { main: "肌内側の弾力"},
          { main: "スキンブースティング"},

        ],
        肌悩み: [
          "二重顎",
          "頬のもたつき",
          "顎のライン",
          "肌の乾燥",
     
        
        ],
        "Accessory Compatibility": [
,
        ],
        Bluetooth: [
          "https://cdn.shopify.com/s/files/1/0156/3905/2336/files/compare_bluetooth.png?v=1768200396",
        ],
   
        アプリ連動: [
          "可能",
        ],
      },
    },
  };

 
  function applyResponsiveCompareUI() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    const thirdSelect = $(".product_select").eq(2);
    const thirdLine = $(".compare_line").eq(2);

    if (isMobile) {
      thirdLine.hide();
      thirdSelect.prop("disabled", true).hide();
    } else {
      thirdLine.show();
      thirdSelect.prop("disabled", false).show();
    }
  }

  function saveState() {
    const stateToSave = [];
    $(".product_select").each(function (index) {
      const $sel = $(this);
      if ($sel.is(":disabled") || !$sel.is(":visible")) return;

      const productId = $sel.val();
      const activeIndex = $(".compare_line").eq(index).data("activeIndex") || 0;
      stateToSave.push({ id: productId, activeIndex: activeIndex });
    });

    sessionStorage.setItem("productCompareState", JSON.stringify(stateToSave));
  }


  function updateAllDisplays() {
    $(".compare_line").each(function (index) {
      const $sel = $(".product_select").eq(index);

      if ($sel.is(":disabled") || !$sel.is(":visible")) {
        $(".product_info").eq(index).html("");
        return;
      }

      const productId = $sel.val();
      if (!productData[productId]) return;

      const product = productData[productId];
      updateProductInfo(product, index);
    });
    updateAllSpecs();
  }

  
  function updateProductInfo(product, index) {
    const productInfoContainer = $(".product_info").eq(index);
    const productColumn = $(".compare_line").eq(index);

    const activeIndex = productColumn.data("activeIndex") || 0;

    const imagesHtml = product.info.images
      .map((imageObject, i) => {
        const widthStyle = imageObject.width ? `style="width:${imageObject.width};"` : "";
        const activeClass = i === activeIndex ? "on" : "";
        return `<img src="${imageObject.src}" class="${activeClass}" ${widthStyle} />`;
      })
      .join("");

    const colorsHtml = product.info.colors
      .map((color, i) => {
        const activeClass = i === activeIndex ? "on" : "";
        return `<i style="background-color:${color};" class="${activeClass}"></i>`;
      })
      .join("");

    const infoHtml = `
      <div class="thumb_image">${imagesHtml}</div>
      <div class="thumb_type">${colorsHtml}</div>
      ${product.info.link ? `<a href="${product.info.link}" class="more show">詳しく見る</a>` : ""}
    `;
    productInfoContainer.html(infoHtml);
  }


  function updateAllSpecs() {
    const specList = $(".spec_list .spec");
    specList.html("");

    const selectedProductIds = $(".product_select")
      .filter(":visible:not(:disabled)")
      .map(function () {
        return $(this).val();
      })
      .get();

    specList.each(function () {
      const specGroup = $(this);
      const specTitle = specGroup.prev(".spec_sub_title").text();
      let maxSpecCount = 0;

      $.each(selectedProductIds, function (_, id) {
        const product = productData[id];
        if (product) {
          const specLength = product.specs[specTitle] ? product.specs[specTitle].length : 0;
          if (specLength > maxSpecCount) maxSpecCount = specLength;
        }
      });

      if (maxSpecCount === 0) maxSpecCount = 1;

      $.each(selectedProductIds, function (_, id) {
        const product = productData[id];
        const specValues = product && product.specs[specTitle] ? product.specs[specTitle] : [];
        let specItemsHtml = "";

        for (let i = 0; i < maxSpecCount; i++) {
          const defaultValue = i === 0 ? "-" : "";
          const value = specValues[i] || defaultValue;

          if (typeof value === "string" && value.includes(".png")) {
            specItemsHtml += `<img src="${value}" alt="${specTitle}">`;
          } else if (typeof value === "object" && value !== null && value.main) {
            const subText = value.sub ? `<em class="spec_sub_text">${value.sub}</em>` : "";
            specItemsHtml += `<span>${value.main} ${subText}</span>`;
          } else {
            specItemsHtml += `<span>${value}</span>`;
          }
        }

        specGroup.append(`<div class="spec_cont">${specItemsHtml}</div>`);
      });
    });
  }
function ensureUniqueVisibleSelects() {
  const $sels = $(".product_select").filter(":visible:not(:disabled)");
  const used = new Set();

  $sels.each(function () {
    const $sel = $(this);
    let val = $sel.val();

    if (used.has(val)) {
      // 중복이면 아직 안쓴 옵션으로 교체
      $sel.find("option").each(function () {
        const candidate = this.value;
        if (!used.has(candidate)) {
          $sel.val(candidate);
          val = candidate;
          return false; // break
        }
      });
    }

    used.add(val);
  });
}
  //초기화
  function initialize() {
    const savedStateJSON = sessionStorage.getItem("productCompareState");
    let savedState = null;

    if (savedStateJSON) {
      try {
        savedState = JSON.parse(savedStateJSON);
      } catch (e) {
        console.error("저장된 상태 파싱 실패:", e);
        sessionStorage.removeItem("productCompareState");
      }
    }

 const selects = $(".product_select");

const productOrder = [
  "boosterx2",
  "boosterPro",
  "boosterMini",
  "vroller",
  "cleanser",
  "focus",
];

let optionsHtml = "";

productOrder.forEach((id) => {
  const product = productData[id];
  if (!product) return;
  optionsHtml += `<option value="${id}">${product.name}</option>`;
});

selects.html(optionsHtml);

    
    applyResponsiveCompareUI();

    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (savedState && Array.isArray(savedState)) {

      if (savedState[0]) {
        selects.eq(0).val(savedState[0].id);
        $(".compare_line").eq(0).data("activeIndex", savedState[0].activeIndex || 0);
      }
      if (savedState[1]) {
        selects.eq(1).val(savedState[1].id);
        $(".compare_line").eq(1).data("activeIndex", savedState[1].activeIndex || 0);
      }
      if (!isMobile && savedState[2]) {
        selects.eq(2).val(savedState[2].id);
        $(".compare_line").eq(2).data("activeIndex", savedState[2].activeIndex || 0);
      }
    } else {
      // 기본값
      if (isMobile) {
        selects.eq(0).val("boosterx2");
        selects.eq(1).val("boosterPro");
        selects.eq(2).val("boosterMini");
        selects.eq(3).val("vroller");
        selects.eq(4).val("cleanser");
         selects.eq(5).val("focus");
      } else {
        selects.eq(0).val("boosterx2");
        selects.eq(1).val("boosterPro");
        selects.eq(2).val("boosterMini");
        selects.eq(3).val("vroller");
        selects.eq(4).val("cleanser");
         selects.eq(5).val("focus");
      }
    }
   ensureUniqueVisibleSelects();
    
    selects.each(function () {
      $(this).data("prevValue", $(this).val());
    });

    
    selects.on("change", function () {
      const currentSelect = $(this);

     
      if (currentSelect.is(":disabled") || !currentSelect.is(":visible")) return;

      const currentValue = currentSelect.val();
      const selectIndex = selects.index(currentSelect);

      let isDuplicate = false;

      selects
        .not(currentSelect)
        .filter(":visible:not(:disabled)")
        .each(function () {
          if ($(this).val() === currentValue) isDuplicate = true;
        });

     if (isDuplicate) {
        alert("すでに選択されています。");

        const prev = currentSelect.data("prevValue");

      
        const hasPrev = prev && currentSelect.find(`option[value="${prev}"]`).length > 0;

        if (hasPrev) {
          currentSelect.val(prev);
        } else {
          
          currentSelect.prop("selectedIndex", 0);
          currentSelect.data("prevValue", currentSelect.val());
        }

        return;
      }

    
      $(".compare_line").eq(selectIndex).data("activeIndex", 0);

      currentSelect.data("prevValue", currentValue);

      updateAllDisplays();
      saveState();
    });

    $(".compare").delegate(".thumb_type i", "click", function () {
      const target = $(this);
      const productColumn = target.closest(".compare_line");
      const colIndex = $(".compare_line").index(productColumn);

      const relatedSelect = $(".product_select").eq(colIndex);
      if (relatedSelect.is(":disabled") || !relatedSelect.is(":visible")) return;

      const clickedIndex = target.index();
      productColumn.data("activeIndex", clickedIndex);

      target.addClass("on").siblings().removeClass("on");
      const productInfo = target.closest(".product_info");
      productInfo.find(".thumb_image img").removeClass("on").eq(clickedIndex).addClass("on");

      saveState();
    });

    updateAllDisplays();
  }

  initialize();

 
  $(window).on("resize", function () {
    applyResponsiveCompareUI();
    updateAllDisplays();
  });

  //scroll
let lastScrollTop = 0;

$(window).on("scroll", function () {
  const winScroll = $(this).scrollTop(),
        selectTop = $(".prd_compare_wrap .select_container").offset().top,
        selectWrap = $(".prd_compare_wrap .select_container .select_wrap"),
        headerHeight = $(".header-wrapper").innerHeight();

  const isScrollingDown = winScroll > lastScrollTop;

  // ✅ scroll_down 제어 (방향 기준)
  if (isScrollingDown) {
    selectWrap.addClass("scroll_down");
  } else {
    selectWrap.removeClass("scroll_down");
  }

  // ✅ fixed는 방향 상관없이 위치 기준으로만 제어
  if (winScroll >= selectTop - headerHeight) {
    selectWrap.addClass("fixed");
  } else {
    selectWrap.removeClass("fixed");
  }

  lastScrollTop = winScroll <= 0 ? 0 : winScroll;
});

});
